/*
 * @Description: 个人信息
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:09
 * @LastEditTime: 2019-07-24 14:44:32
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 查询用户个人信息
export const getInformation = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/user`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getSysUser'
      }, params))
    }
  })
}
// 修改用户个人信息
export const editInformation = (params, id) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/user`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'editSysUser',
        id
      }, params))
    }
  })
}

// // 获取密码强度
// export const getPwdLevel = () => {
//   return logistice({
//     url: `${LOGISTICE_GATEWAY}website/index/user`,
//     method: 'post',
//     params: {
//       params: JSON.stringify(Object.assign({
//         methodName: 'editSysUser',
//         id
//       }, params))
//     }
//   })
// }
